<div class="logo-container">
	<img class="img" src="/assets/img/logo-adobesign.jpg" />
	<img class="text" src="/assets/img/logo-adobesign-text.jpg" />
</div>

<div class="loading-container" *ngIf="loading">
	<div class="lds-facebook">
		<div></div>
		<div></div>
		<div></div>
	</div>
</div>

<!-- STEP 1 -->
<ng-container *ngIf="!loading && step == 1">
	<div class="text-container">Thanks for your interest in Adobe Acrobat Sign for Procore. The following wizard will guide you through the setup process.</div>
	<div class="button-container">
		<button (click)="selectStart()">Start</button>
	</div>
</ng-container>

<!-- STEP 2 -->
<div [ngClass]="{'hidden': loading || step !== 2}">
	<div class="text-container">Enter the e-mail address that will be used for billing inquiries.</div>
	<form #f="ngForm" [formGroup]="formEmail">
		<div class="form-container">
			<input #inputEmail formControlName="email" [ngClass]="{'valid': emailValid == true, 'invalid': emailValid == false}" (change)="doEmailValidation($event)" />
		</div>
		<div class="button-container" *ngIf="!loading">
			<button class="disabled" *ngIf="!emailValid">Continue</button>
			<button *ngIf="emailValid" (click)="selectCustomer()">Continue</button>
			<button class="secondary" (click)="selectBack()">Back</button>
		</div>
	</form>
</div>

<!-- STEP 3 -->
<div [ngClass]="{'hidden': loading || step !== 3}">
	<div class="text-container">Enter the name of the company that will be used for billing inquiries.</div>
	<form #g="ngForm" [formGroup]="formName">
		<div class="form-container">
			<input #inputName formControlName="name" [ngClass]="{'valid': nameValid == true, 'invalid': nameValid == false}" (change)="doNameValidation($event)" />
		</div>
		<div class="button-container" *ngIf="!loading">
			<button class="disabled" *ngIf="!nameValid">Continue</button>
			<button *ngIf="nameValid" (click)="computeCustomerId()">Continue</button>
			<button class="secondary" (click)="selectBack()">Back</button>
		</div>
	</form>
</div>